import {
  Icons,
  Stack,
  StatusChipV2,
  tokens,
  Typography,
} from '@cast/design-system';
import { formatCurrency, formatPercentage } from '@cast/utils';

const formatCost = (value: number) =>
  formatCurrency(value, { maximumFractionDigits: 2 });

export type CostChangePillVariant = 'amount' | 'percent';

export const CostChangePill = ({
  amount,
  isUp,
  variant = 'amount',
}: {
  amount: number;
  isUp: boolean;
  variant?: CostChangePillVariant;
}) => (
  <Stack direction="row" alignItems="center" gap={10}>
    <StatusChipV2
      color={isUp ? 'error' : 'success'}
      size="small"
      variant="strong"
      label=""
      slots={{
        icon: isUp ? (
          <Icons.ArrowUpRight size={12} />
        ) : (
          <Icons.ArrowDownRight size={12} />
        ),
      }}
      sx={{ borderRadius: tokens.theme.radius.full }}
    />
    <Typography variant="P12B">
      {isUp ? '+' : '-'}
      {variant === 'percent'
        ? formatPercentage(amount, { roundBy: 2 })
        : formatCost(amount)}
    </Typography>
  </Stack>
);
